import BaseService from '../../base/base_service';
import LiveTableFeedsStore from './live_tables_store';
import {REGULATION_CODE_TYPES} from "../regulation/regulation_const";
import _ from "../../utils/underscore";
import { ILiveTableInfo } from './live_table_info';
import ILiveTablesService from './live_tables_service_interface';

export interface ILiveTablesServiceParams {
    liveTablesUrl: string;
	refreshInterval: string;
	getBetLimitsFromLiveTablesEnabled: boolean;
}

export default class LiveTablesService extends BaseService implements ILiveTablesService {

    static CLASS = 'LiveTablesService';

	private _tablesStore: LiveTableFeedsStore;

	private _params: ILiveTablesServiceParams;

    init(params: ILiveTablesServiceParams) {
		super.init(params);
		this._params = params;
	}

	onInitializationCompleted(): Promise<void> {
		this._tablesStore = LiveTableFeedsStore.create({
			serviceFactory: this.serviceFactory,
			...this._params
		});

		return Promise.resolve();
    }

	getTablesInfo(): Promise<{[id: number]: ILiveTableInfo}> {
		return this._tablesStore.getTablesInfo();
	}

	start() {
		return this._tablesStore.start();
	}

	stop() {
		return this._tablesStore.stop();
	}

	/*
	 For logged-in player:
	 If the player is from .com brands - 888Casino (0), CIP (1), CIS (8):
	 If the RegistrationCountry (received from NAP GetAccountDetails on login) = GBR (UK): use the UK regulation id (255).
	 If the RegistrationCountry <> GBR: use the RegulationTypeID from NAP.
	 If the player is not from .com brand: use the current regulation id of the player.
	 In anonymous mode:
	 Use the current regulation id of the player.
	*/
	public getRegulationIDForMinMaxBet(): number {
		let regulationID = -1;
		let accountData;
		if(this.serviceFactory.oAuth2Service().isAuthorized() && this.serviceFactory.skinService().isCOMBrand()) {
			accountData = this.serviceFactory.userService().getAccountData();

			if(accountData && accountData.RegistrationCountry && accountData.RegistrationCountry.toLowerCase() === 'gbr') {
				regulationID =  REGULATION_CODE_TYPES.UK;
			} else {
				regulationID = accountData && accountData.RegulationTypeId;
			}
		} else {
			regulationID = this.serviceFactory.skinService().getRegulationID();
		}

		if(_.isNullOrUndefined(regulationID)) {
			this.logger.error(`${LiveTablesService.CLASS}: regulationID is ${regulationID}, isAuthorized
				${this.serviceFactory.oAuth2Service().isAuthorized()}, isCOMBrand: ${
				this.serviceFactory.skinService().isCOMBrand()}.
			  accountData: ${accountData}. RegulationTypeId: ${accountData && accountData.RegulationTypeId}`);
		}

		return regulationID;
	}

	getBetLimitsFromTableFeedsEnabled(): boolean {
		return this._params.getBetLimitsFromLiveTablesEnabled;
	}
}
